// Shared motion tokens.
//
// These three curves were already in the codebase, duplicated as inline
// cubic-bezier literals across VotePage / ChallengeAnimations / progress
// rings. Defining them once keeps the reveal choreography coherent - a
// count-up, a bar fill and a badge entrance that each drift onto their own
// easing read as three unrelated animations rather than one moment.
//
// Every consumer MUST gate on `prefers-reduced-motion`; these tokens only
// describe the shape of a transition, not whether it is allowed to run.

export const EASE_SPRING = 'cubic-bezier(0.34, 1.56, 0.64, 1)'; // overshoot - badge entry
export const EASE_POP = 'cubic-bezier(0.175, 0.885, 0.32, 1.275)'; // badge pop
export const EASE_OUT = 'cubic-bezier(0.16, 1, 0.3, 1)'; // bar fill / progress

export const DUR = {
  micro: 140,
  ui: 240,
  reveal: 420,
  count: 900,
  bar: 750,
};

export const STAGGER = 45; // ms between staggered siblings
